import React from 'react';

import Message from './Message';

const ShareTestMessage = (props) => {
	const is_test = props?.is_test ?? (window?.test ?? false);
	if(!is_test) return null;

	return (
		<Message
			icon='knk-information'
			title_component="strong"
			title="Sharing functionality is disabled in TEST MODE"
			_class={{ other:'in_top not_in_bottom not_awesome' }}
		/>
	);
}

export default ShareTestMessage;